import { frontendURL } from '../../../../helper/URLHelper';
import {
    ROLES,
    CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import PlatformUpdatesHome from './Index.vue';

export default {
    routes: [
        {
            path: frontendURL('accounts/:accountId/settings/platform-updates'),
            component: SettingsWrapper,
            children: [
                {
                    path: '',
                    redirect: to => {
                        return { name: 'platform_updates_list', params: to.params };
                    },
                },
                {
                    path: 'list',
                    name: 'platform_updates_list',
                    meta: {
                        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
                    },
                    component: PlatformUpdatesHome,
                },
            ],
        },
    ],
};
